<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    title="驳回"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="驳回原因" prop="returnReason">
              <el-input
                :autosize="{ minRows: 3, maxRows: 5}"
                v-model="rowInfo.returnReason"
                placeholder="驳回原因"
                type="textarea"
                resize = "none"
                style="width:90%;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">驳回</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { adminAudit } from  "@/api/order/orderinfo"
export default {
  components: {
  },
  computed: {
  },
  data() {

    return {
      visible: false,
      formName: '驳回',
      loading: false,
      rowInfo: {
        id:'',
        returnReason: '',
        approvalStatus:'10020003'
      },
      rules: {
        returnReason: [{ required: true, message: '必填:驳回原因', trigger: 'blur' }]
      }
    }
  },
  mounted() {
  },
  methods: {
    init(id) {
      this.visible = true
      this.rowInfo.id = id
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          adminAudit(this.rowInfo).then((res) => {
              this.$message.success("驳回成功")
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
             this.closeForm()
          })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        id:'',
        returnReason: '',
        approvalStatus:'10020003'
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
